import { getMonetUnit } from "@/pages/dashboard/utils/moneyUnit";

export const FORM_MAP = {
  RANGE_TIME: 'rangeTime',
  RANGE_TIME_DIFF: 'diff',
  RANGE_TIME_TYPE: 'timeType',
  ZONE: 'zone',
  REGION: 'region',
  SYSTEM: 'system',
  CHANNEL: 'channel',
  LANGUAGE: 'language',
  RANGE_DEFAULT: 'rangeDefualt'
};

export const QUERY_PERIOD = {
  Day: 'daily',
  Week: 'weekly',
  Month: 'monthly',
};

export const timeTabs: any = [{ tabName: 'Day' }, { tabName: 'Week' }, { tabName: 'Month' }];
export const PAGE_ID = 'retention';

export const METRICS_COLORS = ['#5086F3', '#77E097', '#6A7597', '#F8CC6A', '#A08FF2', '#5EC8F1', '#CF61AC', '#F19E55', '#387F7D', '#F17C86', '#8EB9FF'];
/**
 * RetentionTable组件 tag属性的值.
 */
export const TABLE_TAG = {
  NEW: 'new',
  ACTIVE: 'active',
};

export const TAB_ID_NEW_USERS = 'new';
export const TAB_ID_ACTIVE_USERS = 'active';
export const TAB_ID_RETENTION_USERS = 'retention';
export const TAB_ID_RETURN_USERS = 'return';

// tab切换
export const TABS = [
  { id: TAB_ID_NEW_USERS, label: 'New Users', pageId: '130001', pageName: 'retentionIndexNewUsers', pagePath: '/retention/index/new' },
  { id: TAB_ID_ACTIVE_USERS, label: 'Active Users', pageId: '130002', pageName: 'retentionIndexActiveUsers', pagePath: '/retention/index/active' },
  // { id: TAB_ID_RETENTION_USERS, label: 'Retention Users', pageId: '130003', pageName: 'retentionIndexRetentionUsers', pagePath: '/retention/index/retention' },
  // { id: TAB_ID_RETURN_USERS, label: 'Return Users', pageId: '130004', pageName: 'retentionIndexReturnUsers', pagePath: '/retention/index/return' },
];

/**
 * separated分组标识
 */
export const GROUPS = {
  separated: 'Separated',
};

/**
 * Accumulated筛选器默认值
 */
export const ACCUMLATED_DEFAULT_VALUE = 'accumulated';

/**
 * Accumulated选项组配置
 */
export const ACCUMULATED_OPTIONS = [
  {
    value: ACCUMLATED_DEFAULT_VALUE,
    text: 'Accumulated',
  },
];

/**
 * Separated选项组配置
 */
export const SEPARATED_OPTIONS = [
  {
    groupKey: 'separated',
    value: 'zone',
    text: 'by Zone',
  },
  {
    groupKey: 'separated',
    value: 'region',
    text: 'by Region',
  },
  {
    groupKey: 'separated',
    value: 'country',
    text: 'by Country',
  },
  {
    groupKey: 'separated',
    value: 'system',
    text: 'by System',
  },
  {
    groupKey: 'separated',
    value: 'channel',
    text: 'by Channel ',
  },
];

/**
 * Key Days 默认值
 */
export const KEY_DAYS_DEFAULT_VALUE = 0;

/**
 * Key Days 筛选器选项组
 */
export const KEY_DAYS_OPTIONS = [
  {
    value: 0,
    text: 'Key Days',
    tooltip: '',
  },
  {
    value: 30,
    text: '1 ~ 30 Days',
    tooltip: '',
  },
  {
    value: 60,
    text: '1 ~ 60 Days',
  },
  {
    value: 90,
    text: '1 ~ 90 Days',
  },
  {
    value: 180,
    text: '1 ~ 180 Days',
  },
];

export const LINE_CHART_TITLE = {
  new: 'New',
  active: 'Active',
};

export const PUBLIC_HEIGHT = 350;
export const DWM = {
  Day: 'DAU',
  Week: 'WAU',
  Month: 'MAU',
};

export const SEGMENT_LIST = [
  { text: "Country", value: "country" },
  { text: "Region", value: "region" },
  { text: "Zone", value: "zone" },
];

export const SEGMENT_JSON = {
  country: "Country",
  region: "Region",
  zone: 'Zone'
};
export const SEGMENT_TITLE_JSON = {
  country: "Countries",
  region: "Regions",
  zone: 'Zones'
};

export const HEAT_TABLE_COLUMNS_DEFAULT = [
  {
    key: "1d_ltv",
    title: "1D LTV",
    width: 200
  },
  {
    key: "2d_ltv",
    title: "2D LTV",
    width: 200
  },
  {
    key: "3d_ltv",
    title: "3D LTV",
    width: 200
  },
  {
    key: "7d_ltv",
    title: "7D LTV",
    width: 200
  },
  {
    key: "14d_ltv",
    title: "14D LTV",
    width: 200
  },
  {
    key: "30d_ltv",
    title: "30D LTV",
    width: 200
  },
  {
    key: "60d_ltv",
    title: "60D LTV",
    width: 200
  },
  {
    key: "90d_ltv",
    title: "90D LTV",
    width: 200
  },
  {
    key: "180d_ltv",
    title: "180D LTV",
    width: 200
  },
];


// 相关的本地文本
export const textLocalConfig = [
  {
    id: "common_date",
    key: "date",
  },
  {
    id: "common_Zone",
    key: "zone",
  },
  {
    id: "common_Region",
    key: "region",
  },
  {
    id: "common_Country",
    key: "country",
  },
  {
    id: "common_System",
    key: "system",
  },
  {
    id: "common_Channel",
    key: "channel",
  },
  {
    id: "common_Language",
    key: "language",
  },

  {
    id: "common_Category",
    key: "category",
  },

  {
    id: "common_Product",
    key: "product",
  },
  {
    id: "common_Sum",
    key: "sum",
  },
  {
    id: "common_Max",
    key: "max",
  },
  {
    id: "common_Min",
    key: "min",
  },
  {
    id: "common_Average",
    key: "avg",
  },
  {
    id: "common_Count",
    key: "count"
  },
  {
    id: "common_Average(remove_Null)",
    key: "avg_no_null",
  },
  {
    id: "common_Average(remove_Null&0)",
    key: "avg_no_null_zero"
  },
  {
    id: "common_timezone",
    key: "timezone"
  },
];

export const pcConsoleRevenuePlafromFilterDefault = [
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ]
  }
];

interface RevenueAndUnitsConstant {
  id: string;
  label: string;
  textId: string;
  unit?: string;
  value?: string;
  key: string;
  isNotAccumated?: boolean;
  moleculeKey?: string;
  denominatorKey?: string;
  hidePercent?: boolean;
  isUserType: boolean;
  isPercent?: boolean;
}

export const revenueAndUnitsConstants: RevenueAndUnitsConstant[] = [
  {
    // Net Revenue($)
    id: "units_dlc_revenue",
    label: 'Revenue After Refund & Tax',
    textId: "pc_console_revenue_units_dlc_rev",
    unit: getMonetUnit(),
    value: 'units_dlc_revenue',
    key: 'net_revenue',
    isUserType: false,
  },
  {
    // Net Units
    id: "net_units",
    label: 'Base Game Units After Refund',
    textId: "pc_console_sales_overview_net_units",
    value: "net_units",
    key: "net_units_sold",
    isUserType: true,
  },
  {
    // Net Full Game Revenue($)
    id: "units_net_revenue",
    label: 'Base Game Revenue After Refund & Tax',
    textId: "pc_console_sales_overview_net_full_game_revenue",
    unit: getMonetUnit(),
    value: 'units_net_revenue',
    key: 'units_revenue',
    isUserType: false,
  },
  {
    // Net Full Game Units
    id: "units",
    label: 'Base Game Units After Refund',
    textId: "pc_console_revenue_full_game_units",
    value: "units",
    key: "units_number",
    isUserType: true,
  },
];

export const revenueAndUnitsConstantsBreakdown = (showLifeTimeRefund: boolean) => [
  ...revenueAndUnitsConstants,
  {
    id: "gross_revenue",
    label: 'Revenue',
    textId: "pc_console_revenue_gross_revenue",
    unit: getMonetUnit(),
    key: 'gross_revenue',
    isUserType: false,
  },
  {
    id: "gross_units_sold",
    label: 'Gross Units',
    textId: "pc_console_sales_overview_gross_units_sold",
    key: 'gross_units_sold',
    isUserType: true,
  },
  {
    id: "refund_revenue",
    label: 'Refund Revenue',
    textId: "pc_console_sales_overview_refund_revenue_currency",
    unit: getMonetUnit(),
    key: 'refund_revenue',
    isUserType: false,

  },
  {
    id: "refunded_units",
    label: 'Refunded Units',
    textId: "pc_console_sales_overview_refunded_units",
    key: 'refunded_units',
    isUserType: true,

  },
  {
    id: "third_party_units",
    label: 'Third-party Units',
    textId: "pc_console_sales_overview_third_party_units",
    key: 'third_party_units',
    isUserType: true,
  },
  (showLifeTimeRefund ? {
    id: "lifetime_refund_rate",
    label: 'Lifetime Refund Rate',
    textId: "pc_console_sales_overview_left_time_refund_rate",
    key: 'lifetime_refund_rate',
    isNotAccumated: true,
    moleculeKey: 'lifetime_refund_units',
    denominatorKey: 'lifetime_gross_units',
    isPercent: true,
    hidePercent: true,
    isUserType: false,
  } :
    {
      id: "accumulated_refund_rate",
      label: 'Accumulated Refund Rate',
      textId: "pc_console_sales_overview_refund_rate",
      key: 'accumulated_refund_rate',
      isNotAccumated: true,
      moleculeKey: 'accumulated_chargeback_units',
      denominatorKey: 'accumulated_gross_units',
      isPercent: true,
      hidePercent: true,
      isUserType: false,
    }),
  {
    id: "asp",
    label: 'Average Selling Price (ASP)',
    textId: "pc_console_sales_overview_asp",
    key: 'asp',
    isNotAccumated: true,
    moleculeKey: 'gross_revenue',
    denominatorKey: 'gross_units_online',
    hidePercent: true,
    isUserType: false,
  },

];

